import { FeatureDto } from "Infrastructure/Models/Messages/Dto/FeatureDto";
import { DeviceEnabledDisabledModel } from "./DeviceUtils";

export interface FeatureDeviceModel {
	feature: FeatureDto;
	devices: DeviceEnabledDisabledModel[];
}

export const getNsureRolesDisplayName = (roles: string): string => {
	const parsedRoles = roles.split(";");
	if (parsedRoles.length > 0 && parsedRoles[0] !== "") {
		return parsedRoles
			.map(Number)
			.map((x) => GetNsureRoleDisplayName(x))
			.join("; ");
	}
	return "";
};

export const GetNsureRoleDisplayName = (role: number) => {
	switch (role) {
		case NsureRole.User:
			return "Uživatel";
		case NsureRole.Admin:
			return "Admin";
		case NsureRole.CompanyOwner:
			return "Vlastník společnosti";
		case NsureRole.SysAdmin:
			return "SysAdmin";
		case NsureRole.CalculationManager:
			return "Správce kalkulací";
		case NsureRole.CalculationManagerCallCentrum:
			return "Správce kalkulací - call centrum";
		case NsureRole.SelfInsuranceUser:
			return "Samosjednání";
		case NsureRole.ApiUser:
			return "API uživatel";
		case NsureRole.CalculationViewer:
			return "Prohlížeč kalkulace";
		case NsureRole.CompanyManager:
			return "Správce kalkulací dané organizační jednotky";
		case NsureRole.CompanyManagerIncludeSubCompanies:
			return "Správce kalkulací dané organizační jednotky a podřízených jednotek";
		case NsureRole.ApiAdmin:
			return "Admin uživatel";
		case NsureRole.SpecificUser:
			return "Specifický uživatel";
		default:
			return "";
	}
};

export const getNsureRoles = () => {
	return [
		NsureRole.User,
		NsureRole.Admin,
		NsureRole.CompanyOwner,
		NsureRole.SysAdmin,
		NsureRole.CalculationManager,
		NsureRole.CalculationManagerCallCentrum,
		NsureRole.SelfInsuranceUser,
		NsureRole.ApiUser,
		NsureRole.CalculationViewer,
		NsureRole.CompanyManager,
		NsureRole.CompanyManagerIncludeSubCompanies,
		NsureRole.ApiAdmin,
		NsureRole.SpecificUser,
	];
};

export enum NsureRole {
	// Uživatel
	User = 0,
	// Admin
	Admin = 1,
	// Vlastník společnosti
	CompanyOwner = 2,
	// SysAdmin
	SysAdmin = 3,
	// Správce kalkulací
	CalculationManager = 4,
	// Správce kalkulací - call centrum
	CalculationManagerCallCentrum = 5,
	// Samosjednání
	SelfInsuranceUser = 6,
	// API uživatel
	ApiUser = 7,
	// Prohlížeč kalkulace
	CalculationViewer = 8,
	// Správce kalkulací dané organizační jednotky
	CompanyManager = 9,
	// Správce kalkulací dané organizační jednotky a podřízených jednotek
	CompanyManagerIncludeSubCompanies = 10,
	// Admin uživatel
	ApiAdmin = 11,
	// Specifický uživatel
	SpecificUser = 12,
}

export enum FeatureType {
	Unset = 0,
	Technical = 1,
	Business = 2,
	Undefined = -1,
}

export const GetNsureFeatureTypeDisplayName = (featureType: number) => {
	switch (featureType) {
		case FeatureType.Unset:
			return "Nenastaveno";
		case FeatureType.Technical:
			return "Technická";
		case FeatureType.Business:
			return "Obchodní";
		case FeatureType.Undefined:
			return "Nedefinováno";
		default:
			return "";
	}
};

export enum FeatureCategory {
	Unset = 0,
	General = 1,
	VehicleInsurance = 2,
	PropertyInsurance = 3,
	TravelInsurance = 4,
	LiabilityInsurance = 5,
	LifeInsurance = 6,
	MortgageInsurance = 7,
	Administration = 8,
	Contract = 9,
	Calculation = 10,
	SelfInsurance = 11,
	Email = 12,
	DynamicTable = 13,
	Assistants = 14,
	RepayAbility = 15,
	Investment = 16,
	Undefined = -1,
}

export const GetNsureFeatureCategoryDisplayName = (featureCategory: number) => {
	switch (featureCategory) {
		case FeatureCategory.Unset:
			return "Nenastaveno";
		case FeatureCategory.General:
			return "Obecná";
		case FeatureCategory.VehicleInsurance:
			return "Modul Auta";
		case FeatureCategory.PropertyInsurance:
			return "Modul Majetek";
		case FeatureCategory.TravelInsurance:
			return "Modul Cestovní pojištění";
		case FeatureCategory.LiabilityInsurance:
			return "Modul Odpovědnost";
		case FeatureCategory.LifeInsurance:
			return "Modul Životní pojištení";
		case FeatureCategory.MortgageInsurance:
			return "Modul Hypotéky";
		case FeatureCategory.Administration:
			return "Administrace";
		case FeatureCategory.Contract:
			return "Smlouvy";
		case FeatureCategory.Calculation:
			return "Kalkulace";
		case FeatureCategory.SelfInsurance:
			return "Samosjednávač";
		case FeatureCategory.Email:
			return "Email";
		case FeatureCategory.DynamicTable:
			return "Dynamická tabulka";
		case FeatureCategory.Assistants:
			return "Asistentky";
		case FeatureCategory.RepayAbility:
			return "Schopnost splácet";
		case FeatureCategory.Investment:
			return "Investice";
		case FeatureCategory.Undefined:
			return "Nedefinováno";
		default:
			return "";
	}
};
